import { FundingSource } from './CourseEnrollment.const';

export interface ClientForm {
  unp: string;
  organization: string;
  legalAddress: string;
  postalDiffers: boolean;
  postalAddress: string;
  phone: string;
  email: string;
  signerName: string;
  signerPosition: string;
  signingBasis: string;
  funding: FundingSource;
  passportNumber: string;
  passportIssueDate: string;
  passportIssuer: string;
  individualFullName: string;
}

export const INITIAL_CLIENT_FORM: ClientForm = {
  unp: '',
  organization: '',
  legalAddress: '',
  postalDiffers: false,
  postalAddress: '',
  phone: '',
  email: '',
  signerName: '',
  signerPosition: '',
  signingBasis: '',
  funding: 'own',
  passportNumber: '',
  passportIssueDate: '',
  passportIssuer: '',
  individualFullName: '',
};

export type FormUpdater<T> = <K extends keyof T>(key: K, val: T[K]) => void;
